import { useQuery, useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { settingData } from '../admin/store/features/settingSlice';
import { SettingService } from '@api/';
import { onDefaultError } from '../helpers/commonHelpers';
// Setting Data
const useGetSettingData = (onSuccess, onError) => {
  const getSettingData = useSelector(settingData);
  return useQuery(
    'setting_data',
    () => {
      return SettingService.getSettingData();
    },
    {
      onSuccess,
      onError,
      enabled: getSettingData.setting_get
    }
  );
};
// All Settings
const useGetSettingDataAlways = (onSuccess, onError) => {
  return useQuery(
    'setting_data_all',
    () => {
      return SettingService.getSettingData();
    },
    {
      onSuccess,
      onError
    }
  );
};
// All Settings Data
const useGetGeneralSettingData = (onSuccess, onError) => {
  return useQuery(
    'general_setting_data',
    () => {
      return SettingService.getGeneralSettingData();
    },
    {
      onSuccess,
      onError
    }
  );
};
// Update Setting Data
const useStoreGeneralSettingData = (onSuccess, onError = onDefaultError) => {
  return useMutation(SettingService.storeGeneralSettingData, {
    onSuccess,
    onError
  });
};
const useGetBiometricSettingData = (onSuccess, onError) => {
  return useQuery(
    'bio_metric_setting_data',
    () => {
      return SettingService.getBiometricSettingData();
    },
    {
      onSuccess,
      onError
    }
  );
};
const useStoreBioMetricSettingData = (onSuccess, onError = onDefaultError) => {
  return useMutation(SettingService.storeBioMetricSettingData, {
    onSuccess,
    onError
  });
};

const useGetOtherSettingData = (onSuccess, onError) => {
  return useQuery(
    'other_setting_data',
    () => {
      return SettingService.getOtherSettingData();
    },
    {
      onSuccess,
      onError
    }
  );
};
const useStoreOtherSettingData = (onSuccess, onError = onDefaultError) => {
  return useMutation(SettingService.storeOtherSettingData, {
    onSuccess,
    onError
  });
};

export {
  useGetSettingData,
  useStoreGeneralSettingData,
  useGetSettingDataAlways,
  useGetGeneralSettingData,
  useGetBiometricSettingData,
  useStoreBioMetricSettingData,
  useGetOtherSettingData,
  useStoreOtherSettingData
};
